import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { connect } from 'react-redux'
import { customerNameById, formatKennitala, formatKennitalaAsDate } from '../../utils'
import { createPayerVirtualcard, createPayerDepositSlip, removeTempCC } from '../../api/payers/actions'
import { removeVirtualCard } from '../../api/virtual-card/actions'
import { mapProductToPayer } from '../../api/payers/actions'
import CardForm from '../card-form'

import { fetchNationalRegistry } from '../../api/national-registry/actions'
import FileUploader from '../file-uploader';
import IdCollection from '../id-collection';
import { getCountries } from '../../api/countries/actions';
import { fetchJobs } from '../../api/jobs/actions';
import moment from "moment";
import { setKey } from '../../api/insurance-takers/actions';
import { closeModal } from '../../api/gui/actions';

const kennitala = require('kennitala')


class PhotoIdModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        this.props.dispatch(getCountries());
        this.props.dispatch(fetchJobs());
    }

    componentDidUpdate() {
        if (this.props.insuranceTakers.insuranceTakers[this.props.insuranceTaker] === undefined || (this.props.insuranceTakers.insuranceTakers[this.props.insuranceTaker] && this.props.insuranceTakers.insuranceTakers[this.props.insuranceTaker].modalPopulated === undefined)) {
            this.props.dispatch(setKey({ key: 'modalPopulated', value: true }, this.props.insuranceTaker));
        }
    }

    getInitialValues(insuranceTaker) {
        return this.props.insuranceTakers.insuranceTakers[insuranceTaker]
    }

    getInitialInsuranceTakerValues(insuranceTaker) {
        let initialValues = this.props.tilbod && this.props.tilbod.jsondata ? this.props.tilbod.jsondata.insuranceTakers.insuranceTakers[insuranceTaker] : {}
        if (typeof initialValues.issueDate === "string") {
            if (initialValues.issueDate === "") {
                initialValues.issueDate = null
            } else {
                initialValues.issueDate = moment(initialValues.issueDate, "YYYY-MM-DD").toDate()
            }
        }
        if (typeof initialValues.validUntil === "string") {
            if (initialValues.validUntil === "") {
                initialValues.validUntil = null
            } else {
                initialValues.validUntil = moment(initialValues.validUntil, "YYYY-MM-DD").toDate()
            }
        }
        initialValues.confirm = false
        return initialValues
    }

    handleClose() {
        this.props.dispatch(closeModal(this.props.id))
        console.log("Calin callback from photo id modal")
        this.props.callBack()
    }

    render() {

        const { insuranceTaker, customerId } = this.props


        return (
            <Modal
                isOpen={this.props.gui.signingModals[this.props.id]}
                contentLabel={this.props.title}
            >
                {this.props.title &&
                    <h5>{this.props.title}</h5>
                }
                <button onClick={() => this.props.dispatch(closeModal(this.props.id))} className="close-button" data-close aria-label="Loka glugga" type="button">
                    <span aria-hidden="true">&times;</span>
                </button>

                <IdCollection
                    requirePhoto={this.props.requirePhoto}
                    customerId={customerId}
                    insuranceTaker={insuranceTaker}
                    countries={this.props.countries}
                    jobs={this.props.jobs}
                    dispatch={this.props.dispatch}
                    infoCollection={this.getInitialValues(customerId)}
                    initialValues={this.getInitialValues(insuranceTaker)}
                    successCallback={() => this.handleClose()}
                    hasVID={false}
                // TODO CHECK hasVID
                />

            </Modal>
        )
    }
}


PhotoIdModal.defaultProps = {
    callBack: () => { },
    requirePhoto: true,
}

function mapStateToProps(state) {

    var f = {
        insuranceTakers: {},
        countries: {},
        jobs: {},
        gui: {},
    }
    f.insuranceTakers = (state.insuranceTakers === undefined) ? {} : state.insuranceTakers
    f.countries = (state.countries === undefined) ? {} : state.countries
    f.jobs = (state.jobs === undefined) ? {} : state.jobs
    f.gui = (state.gui === undefined) ? {} : state.gui

    return f;
}

export default connect(mapStateToProps)(PhotoIdModal);